import React, { useEffect } from 'react';
import { Input, DatePicker, Select, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { ExportIcon } from 'assets/icon/dynamic';
import { fetchMasterConfigs } from 'state/actions/masterConfig';
import { fetchPois } from 'state/actions/pois';

function PreviewView({ onBack, previewFields }) {
  const dispatch = useDispatch();
  const { siteId } = useParams();

  const { list, poisList } = useSelector((state) => ({
    list: state.masterConfig.list,
    poisList: state.pois.list,
  }));

  useEffect(() => {
    if (siteId) {
      dispatch(fetchMasterConfigs({ siteId }));
      dispatch(fetchPois({ siteId, categoryId: 'all', type: 'published' }));
    }
  }, [siteId, dispatch]);

  const masterConfig = list?.[0];
  const fields = previewFields?.length
    ? previewFields
    : [...(masterConfig?.fields || [])].sort(
        (a, b) => (a.order || 0) - (b.order || 0)
      );

  const renderField = (field) => {
    switch (field.fieldType) {
      case 'TextField':
        return (
          <Input
            placeholder={`Enter ${field.label}`}
            disabled
          />
        );

      case 'MediaField':
        return (
          <div className="upload-drag-and-drop">
            <ExportIcon size={22} color="#C2C2C2" />
            <p className="upload-title">
              Drag here or <span className="upload-highlight">Browse</span>
            </p>
            <p className="upload-subtitle">
              File format supported: jpg, png, mp4 (Up to 50MB)
            </p>
          </div>
        );

      case 'DatePicker':
        return (
          <div className="dynamic-comp-datepicker-row">
            <DatePicker
              placeholder="Start Date"
              style={{ width: '100%' }}
              disabled
            />
            <DatePicker
              placeholder="End Date"
              style={{ width: '100%' }}
              disabled
            />
          </div>
        );

      case 'Poi':
        return (
          <Select
            mode="multiple"
            placeholder={`Select ${field.label}`}
            style={{ width: '100%' }}
            disabled
          >
            {poisList.map((poi) => (
              <Select.Option key={poi._id} value={poi._id}>
                {poi.name}
              </Select.Option>
            ))}
          </Select>
        );

      default:
        return null;
    }
  };

  return (
    <div className="dynamic-comp">
      <div className="dynamic-comp-header">
        <h2>Preview</h2>
        <button className="dynamic-comp-btn-back" onClick={onBack}>
          <i className="feather-arrow-left" />
          Back
        </button>
      </div>

      <div className="dynamic-comp-preview-card">
        <h3 className="dynamic-comp-preview-title">Add New Card</h3>

        <div className="dynamic-comp-child-center">
          <div className="poi-form">
            {fields.map((field) => (
              <div
                key={field._id}
                className={`form${
                  field.fieldType === 'DatePicker' && field.setAsScheduling
                    ? ' dynamic-comp-child-field--datepicker'
                    : ''
                }`}
              >
                <label className="form-label">
                  {field.label}
                  {field.description && (
                    <Tooltip title={field.description}>
                      <i className="feather-info dynamic-comp-info-icon" />
                    </Tooltip>
                  )}
                  {field.fieldType === 'DatePicker' && field.setAsScheduling && (
                    <span className="dynamic-comp-scheduling-ref">
                      Scheduling Reference
                    </span>
                  )}
                </label>
                {renderField(field)}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PreviewView;
